import React from 'react'

export default class extends React.Component{

  constructor(props)
  {
    super(props);
  }

  render()
  {

    return (
        <button className={`MenuButton btn btn-primary btn-sm center-block mt-2`} 
             onClick={() => this.props.onClick && this.props.onClick()}>
          {this.props.children}
        </button>
    )
  }
}